import React, { useCallback, useContext, useEffect, useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import { get, putToDbIndex } from "../../../lib/comm";
import { setInspectionOffline } from "../../../lib/calculation";
import { MainContext, UpdateContext } from "../../../main-context";
import { useQuery } from "../../helpers/Hooks";
import WizardDetail from "./WizardDetail";
import { Lightbox, LightboxOptions } from "../../../lib/lightbox";

export default function Wizard() {
  const params = useParams();
  const main_context = useContext(MainContext);
  const update_context = useContext(UpdateContext);
  const history = useHistory();
  const query = useQuery();
  const [url, set_url] = useState("");

  // const query = useMemo(() => new URLSearchParams(location.search), [
  //   location.search,
  // ]);

  const update_db = useCallback(
    (data) => {
      if (url) {
        putToDbIndex(url, main_context.status.id, data);
      }
    },
    [main_context.status.id, url]
  );

  useEffect(() => {
    async function call_api() {
      const url =
        "/api/inspections/" +
        params.type +
        "/" +
        params.id +
        "/" +
        params.operationId +
        "/start";
      set_url(url);
      const query_string = {};
      if (query.get("date")) {
        query_string.date = query.get("date");
      }

      if (query.get("inspection_maintainer")) {
        query_string.inspection_maintainer = query.get("inspection_maintainer");
      }

      if (query.get("inspectionId")) {
        query_string.inspectionId = query.get("inspectionId");
      }

      if (query.get("partial")) {
        query_string.partial = "true";
      }

      const data = await get(
        url,
        query_string,
        main_context.status.id,
        update_context,
        history,
        true
      );

      if (data === "comm error") return;

      if (data.errorHtml && data.footer) {
        update_context.update_ui_context((prev) => ({
          ...prev,
          modal: {
            header: data.header,
            errorHtml: data.errorHtml,
            url:
              update_context.settings.subfolder +
              "/wizard/" +
              params.type +
              "/" +
              params.id +
              "/" +
              params.operationId +
              "?partial=true",
            footerType: "inspection",
          },
        }));
        history.goBack();
      } else if (data.errorHtml) {
        alert(data.header + "\n\n" + data.errorHtml);
        history.goBack();
      } else {
        update_context.time_zone.set(data.station.tz);
        update_context.time_zone.setDate(data.date);
        update_context.update_main_context((prev) => ({
          ...prev,
          data: data,
        }));
        setInspectionOffline(
          update_context.update_main_context,
          params.type,
          +params.id
        );
      }
    }

    call_api();
  }, [
    history,
    main_context.status.id,
    params.id,
    params.operationId,
    params.type,
    query,
    update_context,
  ]);

  // offline_number is number of offline done inspections
  // offline_complete is boolean flag which shows is whole inspection complete
  // it uses previous code for checking if whole inspection is done
  // when saving save as main inspection type (maintenance for annual, monthly, quarter...)
  // params.type contains real inspection type
  const setOfflineCount = useCallback(
    (offline_complete, offline_number, oos) => {
      update_context.update_main_context((prev) => {
        const new_main_context = {
          ...prev,
          inspections: {
            ...prev.inspections,
            [params.type]: prev.inspections[params.type].map((el) =>
              +el.id === +params.id &&
              (params.type !== "monthly" || el.type === "monthly")
                ? {
                    ...el,
                    offline_complete: offline_complete,
                    offline_number: offline_complete
                      ? el.count
                      : offline_number,
                    oos: oos,
                  }
                : el
            ),
          },
        };
        if (
          params.type !== "daily" &&
          params.type !== "weekly" &&
          params.type !== "fso" &&
          params.type !== "monthly"
        ) {
          new_main_context.inspections.monthly = new_main_context.inspections.monthly.map(
            (el) =>
              +el.id === +params.id && el.type === params.type
                ? {
                    ...el,
                    offline_complete: offline_complete,
                    offline_number: offline_number,
                    oos: oos,
                  }
                : el
          );
        }
        putToDbIndex(
          "/api/inspections/" +
            (params.type === "daily" ||
            params.type === "weekly" ||
            params.type === "fso"
              ? params.type
              : "maintenance"),
          main_context.status.id,
          new_main_context.inspections
        );
        return new_main_context;
      });
    },
    [main_context.status.id, params.id, params.type, update_context]
  );

  useEffect(() => {
    const options = new LightboxOptions();
    const lightbox = new Lightbox(
      options,
      update_context.settings.url,
      update_context.update_ui_context
    );
    lightbox.init();
    return () => {
      window.$("#lightboxOverlay").remove();
      window.$("#lightbox").remove();
    };
  }, [update_context.settings.url, update_context.update_ui_context]);

  return (
    <MainContext.Consumer>
      {({ data }) => (
        <div className="layout-admin">
          <div className="admin-content" id="admin-content">
            <div className="col-xs-12">
              <h1 style={{ fontSize: "25px" }}>
                <span
                  style={{ color: "#f85c37", cursor: "pointer" }}
                  onClick={() => history.goBack()}
                >
                  &lt;Back
                </span>
              </h1>

              <div className="container">
                <WizardDetail
                  inspection={data}
                  update_db={update_db}
                  set_offline_count={setOfflineCount}
                ></WizardDetail>
              </div>
            </div>
          </div>
        </div>
      )}
    </MainContext.Consumer>
  );
}
